export default __webpack_public_path__ + "static/media/feather_icon.19eae1ec.svg";